const ErrorPage = () => {
  return <>This is Error Page</>;
};

export default ErrorPage;
